import { ContainerSplash } from "./localStyle";

const Splash = () => {
    return (
        <ContainerSplash>
            <img
                className="logoHeader"
                src={process.env.PUBLIC_URL + "/assets/images/empresa/IsoLogo.png"}
                alt="logo"
            ></img>
            <h1>Cargando datos ...</h1>
        </ContainerSplash>
    )
}

export default Splash; 